import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["assistant"];
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useStoreState } from "pullstate";
import Store from "../../../utils/Store";
import { useState, useEffect, useRef } from "react";
import AwesomeIcon from "../../AwesomeIcon";
import { faXmark, faPlus, faPenToSquare, faMessage, faUser, faRectangleHistoryCirclePlus } from "@fortawesome/pro-regular-svg-icons";
import { useCopilotChatSuggestions } from "@copilotkit/react-ui";
import { get } from "lodash";
import { useRouter } from "next/router";
import { useCopilotMessagesContext } from "@copilotkit/react-core";
import { trackEvent } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../utils/mixpanelEvents";
import { getFormattedDate } from "../../../utils";
import useEditConversation from "../utils/services/useEditConversation";
import classNames from "classnames";
import Modal from "../../common/Modal";
import Image from "next/image";
import { useAuth } from "@qure/qure-auth";
var DraggableModal = function DraggableModal(_ref) {
  var children = _ref.children,
    conversationsData = _ref.conversationsData,
    refetchConversations = _ref.refetchConversations;
  var _useCopilotMessagesCo = useCopilotMessagesContext(),
    setMessages = _useCopilotMessagesCo.setMessages;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isDraggableModalOpen: s.isDraggableModalOpen,
        showChatHistory: s.isPastChatOpen,
        aiAssitantWidth: s.aiAssitantWidth,
        patientConversations: s.patientConversations,
        isWorklistCollapsed: s.isWorklistCollapsed,
        isSummaryCollapsed: s.isSummaryCollapsed
      };
    }),
    isDraggableModalOpen = _useStoreState.isDraggableModalOpen,
    showChatHistory = _useStoreState.showChatHistory,
    aiAssitantWidth = _useStoreState.aiAssitantWidth,
    patientConversations = _useStoreState.patientConversations,
    isWorklistCollapsed = _useStoreState.isWorklistCollapsed,
    isSummaryCollapsed = _useStoreState.isSummaryCollapsed;
  var _useState = useState(true),
    showPatientConverasationTab = _useState[0],
    setShowPatientConverasationTab = _useState[1];
  var _conversations = showPatientConverasationTab ? patientConversations : get(conversationsData, ["results"], []);
  var modalRef = useRef(null);

  // All useState hooks must be declared at the top level
  var _useState2 = useState(false),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var _useState3 = useState(false),
    isMobile = _useState3[0],
    setIsMobile = _useState3[1];
  var _useState4 = useState(aiAssitantWidth || 400),
    currentWidth = _useState4[0],
    setCurrentWidth = _useState4[1];
  var _useState5 = useState(200),
    minWidth = _useState5[0],
    setMinWidth = _useState5[1];
  var _useState6 = useState(700),
    maxWidth = _useState6[0],
    setMaxWidth = _useState6[1];
  var _useState7 = useState(false),
    isStudiesOpen = _useState7[0],
    setIsStudiesOpen = _useState7[1];
  var _useState8 = useState(0),
    dragStartX = _useState8[0],
    setDragStartX = _useState8[1];
  var _useState9 = useState(currentWidth),
    dragStartWidth = _useState9[0],
    setDragStartWidth = _useState9[1];
  var _useState0 = useState(null),
    isChatOptionsOpen = _useState0[0],
    setIsChatOptionsOpen = _useState0[1];
  var _useState1 = useState(""),
    editChatTitle = _useState1[0],
    setEditChatTitle = _useState1[1];
  var _useState10 = useState(null),
    editingChatId = _useState10[0],
    setEditingChatId = _useState10[1];
  var editInputRef = useRef(null);
  var optionsDropdownRef = useRef(null);
  var router = useRouter();
  var editConversation = useEditConversation(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
  useEffect(function () {
    if (typeof window !== "undefined") {
      setIsMobile(window.matchMedia("(max-width: 639px)").matches);
    }
  }, []);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (optionsDropdownRef.current && !optionsDropdownRef.current.contains(event.target)) {
        setIsChatOptionsOpen(null);
      }
    };
    if (isChatOptionsOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return function () {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isChatOptionsOpen]);

  // Handle outside clicks for rename input
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (editInputRef.current && !editInputRef.current.contains(event.target)) {
        if (editingChatId) {
          // Find the chat being edited to get its conversation_id
          var chatBeingEdited = _conversations.find(function (chat) {
            return chat.id === editingChatId;
          });
          if (chatBeingEdited) {
            handleSaveRename(chatBeingEdited.conversation_id);
          }
        }
      }
    };
    if (editingChatId) {
      document.addEventListener("mousedown", handleClickOutside);
      return function () {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [editingChatId, _conversations, editChatTitle]);

  // On mobile, close should remove assistant param
  var handleCloseMobile = function handleCloseMobile() {
    var _router$query = router.query,
      assistant = _router$query.assistant,
      rest = _objectWithoutProperties(_router$query, _excluded);
    router.replace({
      pathname: router.pathname,
      query: rest
    }, undefined, {
      shallow: true
    });
    Store.update(function (s) {
      s.isDraggableModalOpen = false;
      s.isDraggableModalMaximized = false;
    });
  };
  var handleChatHistoryClick = function handleChatHistoryClick(chat) {
    if (!showPatientConverasationTab) {
      Store.update(function (s) {
        s.isPastChatOpen = false;
        s.assistantThreadId = chat.conversation_id;
        s.accessPastChat = true;
        s.assistantMode = "simple";
        s.hasChosenAssistantMode = false;
        s.hasUserSentMessage = false;
        s.lastSavedMessageId = "";
        // s.wsEvents = [];
        s.lastSavedUserMessageId = "";
        s.areFrontendToolsEnabled = true;
        s.customSuggestions = [];
      });
    } else {
      Store.update(function (s) {
        s.isPastChatOpen = false;
        s.assistantThreadId = chat.conversation_id;
        s.accessPastChat = true;
        s.assistantMode = "workflow";
        s.hasChosenAssistantMode = true;
        s.hasUserSentMessage = false;
        s.lastSavedMessageId = "";
        // s.wsEvents = [];
        s.lastSavedUserMessageId = "";
        s.areFrontendToolsEnabled = false;
        s.customSuggestions = [];
      });
    }
  };
  useEffect(function () {
    // Find the target section to base width calculations on
    var targetSection = document.querySelector("[data-main-content]") || document.querySelector("main") || document.querySelector('[role="main"]') || document.body;
    if (!targetSection) return;
    var updateWidth = function updateWidth(entries) {
      // Don't update width while dragging
      if (isDragging) return;
      var vw = window.innerWidth;
      var changeinWidthRatio = Store.getRawState().changeInAIAssistantWidth / (Store.getRawState().aiAssitantWidth - Store.getRawState().changeInAIAssistantWidth);

      // Calculate width using original grid fractions
      var calculatedWidth;
      var minWidth;
      var maxWidth;
      if (vw >= 1280) {
        minWidth = vw * (9 / 12) * 1 / 3;
        calculatedWidth = vw * (9 / 12) * 1 / 3 * (1 + changeinWidthRatio);
        maxWidth = minWidth * 1.5;
      } else if (vw >= 1024) {
        minWidth = vw * (9 / 12) * 1 / 3;
        calculatedWidth = vw * (9 / 12) * 1 / 3 * (1 + changeinWidthRatio);
        maxWidth = minWidth * 1.5;
      } else if (vw >= 768) {
        minWidth = vw * (7 / 12) * 1 / 3;
        calculatedWidth = vw * (7 / 12) * 1 / 3 * (1 + changeinWidthRatio);
        maxWidth = minWidth * 1.5;
      } else if (vw >= 640) {
        minWidth = vw * (8 / 12) * 1 / 3;
        calculatedWidth = vw * (8 / 12) * 1 / 3 * (1 + changeinWidthRatio);
        maxWidth = minWidth * 1.5;
      } else {
        // Mobile fallback
        minWidth = vw;
        calculatedWidth = vw;
      }
      setCurrentWidth(calculatedWidth);
      setMinWidth(minWidth);
      setMaxWidth(maxWidth || 700);
      Store.update(function (s) {
        s.aiAssitantWidth = calculatedWidth;
      });
    };

    // Initial calculation
    updateWidth();

    // Set up ResizeObserver to monitor target section changes
    var resizeObserver = new ResizeObserver(updateWidth);
    resizeObserver.observe(targetSection);

    // Also listen to window resize for viewport-based ratio changes
    var handleWindowResize = function handleWindowResize() {
      return updateWidth();
    };
    window.addEventListener("resize", handleWindowResize);
    return function () {
      resizeObserver.disconnect();
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  var handleMouseDown = function handleMouseDown(e) {
    setIsDragging(true);
    setDragStartX(e.clientX);
    setDragStartWidth(currentWidth);
    e.preventDefault();
  };
  useEffect(function () {
    var handleMouseMove = function handleMouseMove(e) {
      if (!isDragging) return;

      // For left-side handle, dragging left makes wider
      var deltaX = dragStartX - e.clientX;
      var newWidth = Math.min(maxWidth, Math.max(minWidth, dragStartWidth + deltaX));
      setCurrentWidth(newWidth);
      Store.update(function (s) {
        s.changeInAIAssistantWidth = newWidth - minWidth;
        s.aiAssitantWidth = newWidth;
      });
    };
    var handleMouseUp = function handleMouseUp() {
      setIsDragging(false);
    };
    if (isDragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "ew-resize";
      document.body.style.userSelect = "none";
    }
    return function () {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, [isDragging, dragStartX, dragStartWidth, minWidth, maxWidth]);
  useCopilotChatSuggestions({
    instructions: "Suggest the most relevant next actions."
  }, []);
  var sidebarStyle = {
    position: "fixed",
    top: "58px",
    right: "0px",
    height: "calc(100vh - 58px)",
    zIndex: 25,
    width: "".concat(currentWidth, "px")
  };
  var handleRenameChat = function handleRenameChat(chat) {
    if (editingChatId && editingChatId !== chat.id) {
      handleCancelRename();
    }
    setIsChatOptionsOpen(null);
    setEditingChatId(chat.id);
    setEditChatTitle(chat.title);
    setTimeout(function () {
      var _editInputRef$current, _editInputRef$current2;
      (_editInputRef$current = editInputRef.current) === null || _editInputRef$current === void 0 || _editInputRef$current.focus();
      (_editInputRef$current2 = editInputRef.current) === null || _editInputRef$current2 === void 0 || _editInputRef$current2.select();
    }, 10);
  };
  var handleSaveRename = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(chatId) {
      var payload, _Store$getRawState$pa, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(editChatTitle.trim() === "")) {
              _context.n = 1;
              break;
            }
            // Don't save empty titles
            handleCancelRename();
            return _context.a(2);
          case 1:
            _context.p = 1;
            // Call your save function here
            payload = {
              conversation_id: chatId,
              title: editChatTitle.trim()
            };
            if (showPatientConverasationTab) {
              payload.patient_id = (_Store$getRawState$pa = Store.getRawState().patientDetail) === null || _Store$getRawState$pa === void 0 ? void 0 : _Store$getRawState$pa.patient_id;
            }
            _context.n = 2;
            return editConversation.mutateAsync(payload).then(function (resp) {
              // Explicitly refetch conversations to ensure UI updates
              if (showPatientConverasationTab) {
                Store.getRawState().refetchPatientConversations();
              } else {
                refetchConversations();
              }
            });
          case 2:
            // Reset editing state
            setEditingChatId(null);
            setEditChatTitle("");
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error("Error renaming chat:", _t);
            // Handle error (maybe show a toast notification)
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleSaveRename(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCancelRename = function handleCancelRename() {
    setEditingChatId(null);
    setEditChatTitle("");
  };
  var handleKeyDown = function handleKeyDown(e, chatId) {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      handleSaveRename(chatId);
    } else if (e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
      handleCancelRename();
    }
  };
  var chatOptions = [{
    name: "Rename Chat",
    icon: faPenToSquare,
    onClick: function onClick(chat) {
      handleRenameChat(chat);
    }
  }
  // {
  //   name: "Delete Chat",
  //   icon: faTrash,
  //   onClick: (chat: any) => {},
  // },
  ];
  var handleSelect = function handleSelect(option, chat) {
    option.onClick(chat);
  };
  var handleAddNewChat = function handleAddNewChat() {
    var _Store$getRawState$pa2;
    if (!showPatientConverasationTab) {
      var payload = {
        title: "New Chat ".concat(new Date())
      };
      editConversation.mutateAsync(payload).then(function (resp) {
        Store.update(function (s) {
          s.isPastChatOpen = false;
          s.assistantThreadId = resp.conversation_id;
          s.assistantMode = "simple";
          s.hasChosenAssistantMode = false;
          s.hasUserSentMessage = false;
        });
        refetchConversations();
      });
    } else if ((_Store$getRawState$pa2 = Store.getRawState().patientDetail) !== null && _Store$getRawState$pa2 !== void 0 && _Store$getRawState$pa2.patient_id) {
      var _Store$getRawState$pa3, _Store$getRawState$pa4;
      var _payload = {
        title: "Patient ".concat((_Store$getRawState$pa3 = Store.getRawState().patientDetail) === null || _Store$getRawState$pa3 === void 0 ? void 0 : _Store$getRawState$pa3.patient_id, " - ").concat(new Date()),
        patient_id: (_Store$getRawState$pa4 = Store.getRawState().patientDetail) === null || _Store$getRawState$pa4 === void 0 ? void 0 : _Store$getRawState$pa4.patient_id
      };
      editConversation.mutateAsync(_payload).then(function (resp) {
        Store.update(function (s) {
          s.isPastChatOpen = false;
          s.assistantThreadId = resp.conversation_id;
          s.assistantMode = "workflow";
          s.hasChosenAssistantMode = true;
          s.hasUserSentMessage = false;
          s.selectedFilterPatientTool = true;
        });
        Store.getRawState().refetchPatientConversations();
      });
    }
  };
  if (!isDraggableModalOpen && !get(router, ["route"], "").includes("/patients/")) return null;
  return /*#__PURE__*/React.createElement(Modal, {
    bgOpacity: true,
    show: isDraggableModalOpen,
    className: classNames("flex flex-col !fixed !h-2/3 bottom-0 !w-[50%]", {
      "!w-[73%] left-[25%]": !isWorklistCollapsed && isSummaryCollapsed,
      "!w-[64%] left-[4%]": isWorklistCollapsed && !isSummaryCollapsed,
      "!w-[94%] left-[4%]": isWorklistCollapsed && isSummaryCollapsed
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center justify-between pr-4 pl-3 border-b border-gray-300 dark:border-gray-600 rounded-t")
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-8 h-8"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/assets/icons/aira-logo-small.svg",
    alt: "aira-logo",
    fill: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "pr-2",
    onClick: function onClick() {
      Store.update(function (s) {
        s.isPastChatOpen = true;
      });
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faRectangleHistoryCirclePlus,
    size: "lg",
    className: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer",
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalOpen = false;
      });
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classNames("relative w-full h-full border-l border-gray-700 transition-all duration-300 ease-in-out overflow-hidden", isStudiesOpen ? "hidden" : "flex")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full w-full ".concat(isMobile ? "items-stretch justify-stretch" : "items-start justify-end", " pointer-events-none transition-opacity duration-300 ").concat(isDraggableModalOpen || get(router, ["route"], "").includes("/patients/") ? "opacity-100" : "opacity-0")
  }, isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "relative bg-white dark:bg-gray-900 w-full h-full m-0 overflow-auto flex flex-col pointer-events-auto will-change-transform transition-all duration-300 ease-in-out"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-4 right-4 z-10"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseMobile,
    "aria-label": "Close",
    className: "text-gray-700 hidden dark:text-gray-100 rounded-full p-2 shadow hover:bg-gray-300 dark:hover:bg-gray-700"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: "env(safe-area-inset-top, 1rem)",
      paddingBottom: "env(safe-area-inset-bottom, 1rem)"
    },
    className: "flex-1 flex flex-col"
  }, children)) : /*#__PURE__*/React.createElement("div", {
    ref: modalRef,
    className: " bg-white dark:bg-gray-900  w-full h-full shadow-[0_0_15px_rgba(0,0,0,0.1)] dark:shadow-[0_0_15px_rgba(0,0,0,0.3)] \n                overflow-auto flex flex-col pointer-events-auto will-change-transform transition-all duration-300 ease-in-out ".concat(!isDragging && "transition-transform duration-300 ease-in-out", " \n            \n              ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full"
  }, children))), showChatHistory && /*#__PURE__*/React.createElement("div", {
    className: "absolute right-0 top-0 bottom-0 w-80 bg-white dark:bg-gray-900 border-l border-gray-300 dark:border-gray-700 z-50 flex flex-col transition-transform duration-300 ease-in-out"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 border-b border-gray-300 dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between mb-3"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-medium text-lg text-gray-800 dark:text-white"
  }, "Chat History"), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isPastChatOpen = false;
      });
    },
    className: "h-6 w-6 p-0 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "w-full h-8 text-base border border-gray-300 dark:border-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition rounded",
    onClick: function onClick() {
      setMessages([]);
      // setShowNewChatModal(false);
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_MODAL_BUTTONS, {
        button_type: "new_chat",
        action: "click"
      });
      handleAddNewChat();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-4 h-4 w-4 text-teal-400"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPlus,
    size: "lg"
  })), "New Chat"), /*#__PURE__*/React.createElement("div", {
    className: "hidden items-center bg-gray-100 dark:bg-gray-800 rounded-md p-2 mt-3"
  }, /*#__PURE__*/React.createElement("button", {
    className: classNames("px-4 py-3 text-md font-medium w-1/2 rounded-md transition-all duration-200", {
      "bg-teal-600 text-white shadow-sm": !showPatientConverasationTab,
      "text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700": showPatientConverasationTab
    }),
    onClick: function onClick() {
      return setShowPatientConverasationTab(false);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMessage,
    size: "sm",
    className: "mr-3"
  }), "General"), /*#__PURE__*/React.createElement("button", {
    className: classNames("px-4 py-3 text-md font-medium w-1/2 rounded-md transition-all duration-200", {
      "bg-teal-600 text-white shadow-sm": showPatientConverasationTab,
      "text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700": !showPatientConverasationTab
    }),
    onClick: function onClick() {
      return setShowPatientConverasationTab(true);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUser,
    size: "sm",
    className: "mr-3"
  }), "Patient"))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 overflow-y-auto p-2 space-y-1"
  }, _conversations.map(function (chat) {
    return /*#__PURE__*/React.createElement("div", {
      key: chat.id,
      className: classNames("p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer group transition-colors", {
        "bg-teal-500/50 rounded-none": chat.conversation_id === Store.getRawState().assistantThreadId
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-start justify-between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-1 min-w-0",
      onClick: function onClick() {
        return handleChatHistoryClick(chat);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-base font-medium text-gray-800 dark:text-gray-200 truncate"
    }, editingChatId === chat.id ? /*#__PURE__*/React.createElement("input", {
      ref: editInputRef,
      type: "text",
      value: editChatTitle,
      onChange: function onChange(e) {
        return setEditChatTitle(e.target.value);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, chat.conversation_id);
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      className: "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white px-2 py-1 rounded w-full"
    }) : chat.title), /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-gray-500 dark:text-gray-500 mt-1"
    }, getFormattedDate(chat.created_at))), /*#__PURE__*/React.createElement("button", {
      className: "opacity-0 group-hover:opacity-100 h-6 w-6 p-0 ml-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200",
      onClick: function onClick(e) {
        e.stopPropagation();
        setIsChatOptionsOpen(isChatOptionsOpen === chat.id ? null : chat.id);
      }
    }, "\u22EF")), /*#__PURE__*/React.createElement("div", {
      className: "ml-4 relative px-4 w-full",
      ref: isChatOptionsOpen === chat.id ? optionsDropdownRef : null
    }, isChatOptionsOpen === chat.id && /*#__PURE__*/React.createElement("div", {
      className: "absolute right-0 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded shadow-lg z-10"
    }, chatOptions.map(function (option) {
      return /*#__PURE__*/React.createElement("div", {
        key: option.name,
        onClick: function onClick() {
          return handleSelect(option, chat);
        },
        className: "px-4 py-2 hover:bg-teal-500 cursor-pointer text-gray-800 dark:text-white"
      }, option.name);
    }))));
  })))));
};
DraggableModal.displayName = "DraggableModal";
export default DraggableModal;